import * as React from "react";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization, IStartMenu } from "../../../models/localization";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./tertiary.css";

@inject("store") @observer
export class Tertiary extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const localization: ILocalization = this.props.store.localization.fields;
    const local: IStartMenu = this.props.store.localization.fields.startMenu;
    if (!local.tertiaryText) { return null;}
    return (<Col xs={12} className={s.container}>
      <Row>
        <Col xs={12}><h2 className={s.header}>{local.tertiaryHeader}</h2></Col>
        <Col xsOffset={1} xs={10} mdOffset={2} md={8} className={s.contentCol}>
          <p>{local.tertiaryText}</p>
        </Col>
      </Row>
    </Col>)
  }
}


// WEBPACK FOOTER //
// ./src/components/start/tertiary/index.tsx